<template>
  <div class="news">
    <div class="row flex-center">
      <div class="col-md-12 banner-img">
        <span class="banner-title" v-text="$t('news.title')"></span>
      </div>
      <div class="col-md-12 news-lists">
        <div v-for="item,i in lists" :key="i">
          <h3>{{ item.title }}</h3>
          <p>{{ item.content }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      msg: "news",
      lists: this.$t('news.lists')
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.banner-img{
  width: 100%;
  height: 508px;
  background: #F5F5F5;
  background-image: url('~@static/img/news/bg.png');
  background-repeat: no-repeat;
  background-size: 1260px 310px ;
  background-position: center 36px;
}
.banner-title {
  position: absolute;
  left: 420px;
  top: 130px;
  font-size: 48px;
  font-weight: 600;
  color: #333;
}
.news-lists{
  max-width: 1200px;
  margin-top: -238px;
  text-align: left;
  background-color: #fff;
  box-sizing: border-box;
  margin: -230px auto 0 auto;
  padding: 42px 50px;
  font-weight: 400;
font-size: 22px;
color: #3D3D3D;
line-height: 40px;
}
.news-lists>div{
border: 1px solid #EEEEEE;
padding: 30px;
margin-bottom: 30px;
}
.news-lists h3{
  font-weight: 400;
font-size: 30px;
color: #3D3D3D;
line-height: 40px;
padding-bottom: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/News.vue